import React from 'react';
import ReactSelect from 'react-select';

import API from '../../../Services/BlockchainList/index.jsx';

class BlockchainSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      options: undefined
    };

    this.handleResponse = this.handleResponse.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.api = new API();
    this.api.fetchPage()
      .then(this.handleResponse);
  }
  
  componentWillUnmount() {
    this._isMounted = false;
  }

  handleResponse(response) {
    if (this._isMounted) {
      this.setState({
        loading: false,
        options: response
      });
    }
  }

  onChange(value) {
    if (this.props.onChange) {
      var selected = [];

      if (value && value.length) {
        for (var i = 0; i < value.length; i++) {
          selected.push(value[i].value);
        }
      }

      this.props.onChange(selected);
    }
  }

  formatOptionLabel(data) {
    return (
      <span dangerouslySetInnerHTML={{ __html: data.label }} />
    );
  }

  render() {
    var selectOptions = [];
    var selectProps = {
      isMulti: true,
      closeMenuOnSelect: false,
      hideSelectedOptions: false,
      placeholder: 'Select Blockchains',
      formatOptionLabel: this.formatOptionLabel,
      onChange: this.onChange
    };

    if (this.state.loading) {
      selectProps.isLoading = true;
    } else {
      var selectValue = [];

      for (var i = 0; i < this.state.options.length; i++) { 
        var option = this.state.options[i];

        if (this.props.value.indexOf(option.id) > -1) {
          selectValue.push({ value: option.id, label: option.title });
        }

        selectOptions.push({ value: option.id, label: option.title });
      }

      selectProps.value = selectValue;
    }


    return (
      <div className="my-3">
        <ReactSelect {...selectProps} options={selectOptions} />
      </div>
    );
  }
}


export default BlockchainSelect;

